import { useEffect, useRef } from 'react';

import { useSessionActions } from '../coachSchedule/useSessionActions';

import type { CalendarActionSubject } from '../appointments/calendarAppointmentProjection';

export interface OpsMemberSessionPendingAction {
  action: 'cancel' | 'reschedule';
  coachId: string;
  nonce: number;
  returnFocus: () => void;
  subject: CalendarActionSubject;
}

interface OpsMemberSessionActionsProps {
  pending: OpsMemberSessionPendingAction;
  timeZone: string;
  onDone: () => void;
}

// MEN-5338: useSessionActions captures adminCoachId when it renders, so the
// parent cannot set a new coach and open in the same click. Mount one instance
// per opened row (keyed by the caller) and open from a mount effect instead.
const OpsMemberSessionActions = ({
  pending,
  timeZone,
  onDone,
}: OpsMemberSessionActionsProps) => {
  const actions = useSessionActions(timeZone, {
    adminCoachId: pending.coachId,
    onClose: onDone,
  });
  const { openCancel, openReschedule } = actions;
  const opened = useRef(false);
  useEffect(() => {
    // StrictMode replays mount effects; open the drawer exactly once.
    if (opened.current) return;
    opened.current = true;
    if (pending.action === 'cancel') {
      openCancel(pending.subject, pending.returnFocus).catch(() => undefined);
    } else {
      openReschedule(pending.subject, pending.returnFocus);
    }
  }, [openCancel, openReschedule, pending]);
  return actions.modals;
};

export default OpsMemberSessionActions;
